import "./Card.css";

import { CardProps } from "./CardProps";

export const Card = ({ children, height, padding = "ml", corners = "default" }: CardProps): JSX.Element => {
  return (
    <div className={`Card Padding_${padding} Corners_${corners}`} style={{ height: height ?? "auto" }}>
      {children}
    </div>
  );
};
